// eslint-disable-next-line no-shadow
enum EventTypes {
  CHANGE_POSITION = 'CHANGE_POSITION',
  CALC_POSITION = 'CALC_POSITION',
  SET_POSITION = 'SET_POSITION',
  HANDLER_MOUSEDOWN_EVENT = 'HANDLER_MOUSEDOWN_EVENT',
  HANDLER_MOUSEMOVE_EVENT = 'HANDLER_MOUSEMOVE_EVENT',
}

export default EventTypes;
